import type { TExcoInitOptions } from "./types";

export const EXCO_PLAYER_ID = "04043c8f-f764-4ce2-bc71-6a3a675e398b";

export interface ExcoPlayerClient {
  init(options?: TExcoInitOptions): Promise<void>;
  play(): void;
  setVolume(volume: number): Promise<void>;
  on(eventName: string, handler: () => void): void;
  destroy(): void;
}

let loadPromise: Promise<void> | undefined;

function loadExcoPlayer(): Promise<void> {
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(
        `script.exco-player[src*="${EXCO_PLAYER_ID}"]`,
      );
      if (existing?.dataset.loaded === "true") {
        resolve();
        return;
      }

      const script = existing ?? document.createElement("script");
      script.src = `//player.ex.co/player/${EXCO_PLAYER_ID}`;
      script.className = "exco-player";
      script.setAttribute("programmatic", "true");
      script.onload = () => {
        script.dataset.loaded = "true";
        resolve();
      };
      script.onerror = () => {
        loadPromise = undefined;
        reject(new Error("Unable to load the ExCo player."));
      };
      if (!existing) (document.head || document.body).appendChild(script);
    });
  }
  return loadPromise;
}

export type { TExcoInitOptions } from "./types";

export async function createExcoPlayer(
  options: TExcoInitOptions,
): Promise<ExcoPlayerClient> {
  await loadExcoPlayer();
  const player = window.ExCoPlayer.connect();
  await player.init(options);
  return player;
}
